import { render, staticRenderFns } from "./BtnRestartPackage.vue?vue&type=template&id=2a64717a"
import script from "./BtnRestartPackage.vue?vue&type=script&lang=js"
export * from "./BtnRestartPackage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports